// https://fontawesome.com/icons?d=gallery&s=brands,solid&m=free

export const dashboardRoutes = {
  name: "Dashboard",
  to: process.env.PUBLIC_URL + "/user/dashboard",
  exact: true,
  icon: ["fab", "trello"],
  //icon: ['far', 'coffee']
};

export const applicationsRoutes = {
  name: "Application(s)",
  to: process.env.PUBLIC_URL + "/user/applications",
  icon: "users",
};

// export const analyticsRoutes = {
//   name: "Analytics",
//   to: process.env.PUBLIC_URL + "/user/analytics",
//   icon: "chart-pie",
//   children: [
//     {
//       to: process.env.PUBLIC_URL + "/user/analytics/api-requests-response",
//       name: "API Request & Response",
//     },
//   ],
// };

export const documentationRoutes = {
  name: "Documentation",
  to: process.env.PUBLIC_URL + "/user/documentation",
  icon: "book",
  linkIcon: "faUpRightFromSquare",
  children: [
    {
      to: process.env.PUBLIC_URL + "/user/documentation/api-documentation",
      name: "API Documentation",
    },
    {
      to: process.env.PUBLIC_URL + "/user/documentation/api-documentation",
      name: "Writeback APIs",
    },
    {
      to: process.env.PUBLIC_URL + "/user/documentation/pmses-supported",
      name: "PMSes Supported",
      // controlID: "liPmsSupported",
    },
    {
      to: process.env.PUBLIC_URL + "/user/documentation/data-visualization",
      name: "Data Visualization",
    },
    {
      to: process.env.PUBLIC_URL + "/user/documentation/api-documentation",
      name: "Practice Onboarding",
    },
    // {
    //   to: process.env.PUBLIC_URL + "/user/documentation/apidocs",
    //   name:"Api Docs",
    //   // controlID: "liapidocs",
    // },
  ],
};

export const webhookRoutes = {
  name: "Webhook",
  to: process.env.PUBLIC_URL + "/user/webhook",
  icon: "poll",
  exact: true,
};

export const notifyRoutes = {
  name: "Notify",
  controlID: "liNotify",
  to: process.env.PUBLIC_URL + "/user/notify",
  icon: "bell",
  exact: true,
};

export const apiExplorerRoutes = {
  name: "API Explorer",
  to: process.env.PUBLIC_URL + "/user/api-explorer",
  exact: true,
  icon: "copy",
};

export const errorCodesRoutes = {
  name: "Error Codes",
  to: process.env.PUBLIC_URL + "/user/error-codes",
  exact: true,
  icon: "triangle-exclamation",
};

export const bulkExportRoutes = {
  name: "Bulk Export",
  controlID: "liBulkExport",
  to: process.env.PUBLIC_URL + "/user/bulk-export",
  exact: true,
  icon: "cloud-arrow-down",
};

export const settingsRoutes = {
  name: "Settings",
  to: process.env.PUBLIC_URL + "/user/settings",
  icon: "code-branch",
  children: [
    { to: process.env.PUBLIC_URL + "/user/settings/profile", name: "Profile" },
    { to: process.env.PUBLIC_URL + "/user/settings/ghlconfiguration",name: "GoHighLevel Configuration" },
  ],
};

export const publishApplicationRoutes = {
  name: "Publish Application",
  to: process.env.PUBLIC_URL + "/user/publish-application",
  icon: "faCloudUploadAlt",
  exact: true,
};

export const APIStatusRoutes = {
  name: "API Status",
  to: process.env.PUBLIC_URL + "/user/api-status",
  icon: "faChartBar",
  exact: true,
};

export const SPUSupportRoutes = {
  name: "SPU Support",
  to: process.env.PUBLIC_URL + "/user/spu-support",
  icon: "faTachometerAlt",
  exact: true,
};

export const billingRoutes = {
  name: "Billing",
  to: process.env.PUBLIC_URL + "/user/billing",
  icon: "cart-plus",
  exact: true,
};

export const apiFieldsRelationshipPartner = {
  name: "API Field Relationship",
  to: process.env.PUBLIC_URL + "/user/api-field-relationship",
  icon: "folder-tree",
  exact: true,
};
// export const askMe = {
//   name: "Ask Me..!",
//   controlID: "liAskMe",
//   to: `${process.env.PUBLIC_URL}/user/Chatbox`,
//   icon: "rocketchat",
//   exact: true,
// };

export const supportRoutes = {
  name: "Support",
  to: process.env.PUBLIC_URL + "/user/writeback",
  icon: "circle-info",
  children: [
    {
      to: process.env.PUBLIC_URL + "/user/support/writeback",
      name: "Writeback",
    },
    // {
    //   to: process.env.PUBLIC_URL + "/user/support/customerhealthcheck",
    //   name: "Customer Health Check",
    // },
    // { to: process.env.PUBLIC_URL + "/user/support/tickets", name: "Tickets"},
    { to: process.env.PUBLIC_URL + "/user/support/alerts", name: "Alerts" },
  ],
};

// export const spudetails = {
//   name: "SPU Details",
//   to: process.env.PUBLIC_URL + "/user/spudetails",
//   icon: "computer",
// };
export const spuRoutes = {
  name: "SPU",
  to: process.env.PUBLIC_URL + "/user/spudashboard",
  icon: "computer",
  badge: {
    type: 'success',
    text: "New"
  },
  children: [
    {
      to: process.env.PUBLIC_URL + "/user/spudashboard",
      name: "Dashboard",
      badge: {
        type: 'success',
        text: "New"
      }
    },
    {
      to: process.env.PUBLIC_URL + "/user/support/customerhealthcheck",
      name: "Customer Health Check",
    },
    {
      to: process.env.PUBLIC_URL + "/user/spudetails",
      name: "SPU Details"
    }
  ],
};
export default [
  applicationsRoutes,
  // analyticsRoutes,
  documentationRoutes,
  webhookRoutes,
  // notifyRoutes,
  publishApplicationRoutes,
  APIStatusRoutes,
  // SPUSupportRoutes,
  apiExplorerRoutes,
  errorCodesRoutes,
  bulkExportRoutes,
  settingsRoutes,
  billingRoutes,
  supportRoutes,
  apiFieldsRelationshipPartner,
  //spudetails,
  spuRoutes,
  // askMe
];
